import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CoordinatorFrameClass;
function CoordinatorFrame() {
  if (CoordinatorFrameClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.lineHeight' call
        this.native_1.style_1.native_1.lineHeight = '0px';
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
    }
    initMetadataForClass($, 'CoordinatorFrame');
    CoordinatorFrameClass = $;
  }
  return CoordinatorFrameClass;
}
//region block: exports
export {
  CoordinatorFrame as CoordinatorFrame1xeiax3dpykfa,
};
//endregion

//# sourceMappingURL=CoordinatorFrame.commonHtml.mjs.map
